import React, { lazy } from "react";
import { docLazyFn } from '@/router/untilFn'

// 沙盒-导航栏
import SandBox from '@/components/SandBox'


import BankBalanceSummary from '@/views/Dashboard/BankBalanceSummary/index'
import GeneralLedgerReport from '@/views/Dashboard/GeneralLedgerReport/index'
import OneLineCashFlowReport from '@/views/Dashboard/OneLineCashFlowReport/index'
import CashPositionReport from '@/views/Dashboard/CashPositionReport/index'
import Accounting8825Report from '@/views/Dashboard/Accounting8825Report/index'
import RESReport from '@/views/Dashboard/RESReport/index'
import ResMortgage from '@/views/Dashboard/ResMortgage/index'
import DailyDeposit from '@/views/Dashboard/RPSFileReport/index'
import TransDailyDeposit from '@/views/Dashboard/RPSTransReport/index'
import Mortgage from '@/views/Dashboard/Mortgage/index'
// import Delinquency from '@/views/Dashboard/Delinquency/index'
import Delinquency from '@/views/Dashboard/Collection/tabs'
// import Vacancy from "@/views/Dashboard/Vacancy/tabs"
import Vacancy from "@/views/Dashboard/Vacancy/component/SnapshotIndex"
import OperatingStatement from "@/views/Dashboard/OperatingStatementAnalysis/tabs"
import VacancyEvictionBalanceReport from "@/views/Dashboard/VacancyEvictionBalanceReport/index"

const dashboardRouter = [
  {
    path: "/dashboard",
    element: <SandBox />,
    children: [
      {
        path: "OperatingStatement",
        element: docLazyFn(<OperatingStatement />),
      },  {
        path: "BankBalanceSummary",
        element: docLazyFn(<BankBalanceSummary />),
      },  {
        path: "GeneralLedgerReport",
        element: docLazyFn(<GeneralLedgerReport />),
      },
      {
        path: "OneLineCashFlowReport",
        element: docLazyFn(<OneLineCashFlowReport />),
      },
      {
        path: "CashPositionReport",
        element: docLazyFn(<CashPositionReport />),
      },
      {
        path: "Accounting8825Report",
        element: docLazyFn(<Accounting8825Report />),
      },
      {
        path: "RESReport",
        element: docLazyFn(<RESReport />),
      },
      {
        path: "ResMortgage",
        element: docLazyFn(<ResMortgage />),
      },
       {
        path: "DailyDeposit",
        element: docLazyFn(<DailyDeposit />),
      }, {
        path: "TransDailyDeposit",
        element: docLazyFn(<TransDailyDeposit />),
      }, {
        path: "Delinquency",
        element: docLazyFn(<Delinquency />),
      },
       {
        path: "Vacancy",
        element: docLazyFn(<Vacancy />),
      },
      {
        path: "VacancyEvictionBalanceReport",
        element: docLazyFn(<VacancyEvictionBalanceReport />),
      },
    ],
  }
];

export default dashboardRouter;
